import React from 'react';
import Positions from '../../components/careers/positions';
import Parks from '../../components/careers/parks';
import { NextSeo } from 'next-seo';
import PageBanner from '@apps/components/pageBanner';
import { usePostListingQuery } from '../../graphql/api';

const postFilter = {
  filters: {
    companies: {
      slug: {
        eq: "alchemis"
      }
    },
    post_type: {
      post_type_slug: {
        eq: "career"
      }
    }
  }
}


const Careers = () => {
  const metaTitle = "Career - Alchemis";
  const metaDesc = `Be part of our young and innovative team, and we build trust, embrace feedback, grow rapidly, and love our work.`;
  const metaImg = `/images/meta/general.png`;

  const itemList = [
    {
      containerClass: 'w-1/2',
      row: [
        {title: 'Flexible hours'},
        {title: 'Unlimited drinks & coffee'},
        {title: 'Team dinner'},
      ]
    },
    {
      containerClass: 'w-1/2',
      row: [
        {title: 'Challenging Work'},
        {title: 'Snacks in Locker'},
        {title: 'Company trip'},
      ]
    }
  ];

  // Todo : if Loading do preloader
  const { data: postListingData, loading } = usePostListingQuery({
    variables: {
      ...postFilter,
    }
  });

	return (
		<div>
      <NextSeo
        title={metaTitle}
        description={metaDesc}
        openGraph={{
          title: `${metaTitle}`,
          description: `${metaDesc}`,
          images: [
            {
              url: `${metaImg}`,
            }
          ]
        }}
      />
      <PageBanner text="Join the Alchemis Team!" description="Be part of our young and innovative team, and we build trust, embrace feedback, grow
							rapidly, and love our work." image={'/images/about/banner-bg.png'} />
			<Positions positionsList={(postListingData?.posts?.data.length > 0) ? postListingData?.posts?.data : []} />
			<Parks
        title={'Our Perks when you join the team.'}
        subTitle1={'Employees are our number-one priority, so we like to take care of them!'}
        subTitle2={'Every digital creation available through MakersPlace is an authentic and truly unique digital creation, signed and issued by the creator — made possible by blockchain technology. Even if the digital creation is copied, it won\'t be the authentic and originally signed version.'}
        image={'/images/process.png'}
        animationImage={'/images/token-tool/tokentool-side.png'}
        list={itemList}
      />
		</div>
	);
};

export default Careers;
